module.exports = __webpack_public_path__ + "img/subscribed.5d8f0b7c.svg";